export default "/dist/files/icon-coupe-blanc.698c8f7ee5731b884483bfd719deb1bd.svg";